/**
 * Broker action-items client (DEV-3636, Skynet.Loans behind the loans gateway).
 * GET /api/brokerActionItems returns the sub-company subtree's open broker-facing
 * items, server-scoped from the authenticated user. PII is minimized at the
 * source to borrower last name + loan last-4.
 *
 * Response shape:
 *   { items: [{ id, severity, category, borrowerLastName, loanNumberLast4,
 *               applicationId, dueDate, message }], asOf }
 */
export class BrokerActionItemsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCommandCenterActionItems({ config = {} } = {}) {
    return this.#http.get('/api/command-center/action-items', config);
  }
}
